export const replaceFirstLetters = (input: string = '', n: number): string => {
  return input.replace(new RegExp(`^.{${n}}`), '*'.repeat(n));
};
